import React from 'react'
import { useTheme, makeStyles, Container, Typography } from '@material-ui/core'
import { Article } from './article'
import { InfoBox } from './infobox'
import { ContactButton } from './contactbutton'
import { HeroImage } from './heroimage'

export const Content = () => {
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <div className={classes.container}>
            <InfoBox title={"Västerås mest prisvärda bilservice"} body={ "Här på Hedis bilverkstad erbjuder vi service med en hög kvaliet och ett lågt pris, för bara 999kr får du både service och 4 liter högklassig olja på köpet!"} 
              extra={<ContactButton text={"Ring oss"}/>} />
            <Article title={"Om Hedis Bilverkstad"} body={"Sedan 2007 har Hedis Bilverkstad funnits på Slakterigatan 2 i Västerås. Där har vi kunnat erbjuda service och reparationer av högsta kvalitét till både privatpersoner och företag i över 13 år. På grund av vårt läge har vi inte så hög hyra som de stora bilverkstadskjedjorna och kan därför erbjuda dig lägre priser. Vi har dessutom en unik fördel eftersom vår grundare Hedie har en bakgrund som mekanisk ingenjör och därför har en mycket bredare och djupare kunskap om mekanik än de flesta bilmekaniker i Västerås!"} />
            <HeroImage />
            <InfoBox title={"Alltid garanti"} body={ "Hedis Bilverkstad är en cerifierad bilverkstad och erbjuder alltid 2 års garanti på alla utförda arbeten och alla reservdelar vi använder. Dessutom utförs alla uppdrag av erfarna mekaniker som kan hjälpa dig med allt från däckbyte till att ersätta avgassystemet." } />
            <Article title={"Tjänster"} body={"På Hedis bilverkstad tar vi hand om din bil och ger den den service den behöver och lite till. Vi kan också hantera vanliga problem, skador och andra komplikationer på ett smidigt sätt. Ring eller maila och berätta om vad du behöver så löser vi dina problem! Just nu, 2020, har vi följande priser på dessa vanliga åtgärder:"} />
            <Article title={""} body={
              <ul>
                <li>Byte av oljefilter - 999kr</li>
                <li>Bromsbyte (Arbetstid) - 1200kr</li>
                <li>Kamremsbyte - ca 2000kr beroende på märke och modell</li>
                <li>Däckbyte - 199kr</li>
              </ul>
            } />
            <InfoBox title={"Klara besiktningen"} body={"Har din bil har fått anmärkningar som måste åtgärdas? Vi har korta väntetider och enklare åtgärder kan vi ofta lösa på drop-in. Ring oss så hittar vi en bra lösning för dig!"} 
              extra={<ContactButton text={"Ring oss"}/>} />
        </div>
    )
}

const useStyles = makeStyles({
    container: theme => ({
      backgroundColor: theme.palette.background.main,
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      height: '100%',
      textAlign: 'center',
      position: 'relative',
      overflow: 'auto',
      padding: '0 1rem',
      alignItems: 'center '
    })
})